import { Form, Input, message, Select } from 'antd'
import React, { useEffect, useMemo } from 'react'

export default function CompositeInput(props) {
    const { disabled, inputData } = props;

    const rules = useMemo(() => {
        return inputData?.primaryForm?.form?.rules || []
    }, [inputData])

    return (
        <Form.Item noStyle {...inputData?.primaryForm?.form} rules={rules}>
            <Input
                disabled={disabled}
                placeholder={inputData?.primaryForm?.placeholder}
                addonBefore={inputData?.prefixForm && <PrefixForm {...props} />}
            />
        </Form.Item>
    )
}


const PrefixForm = (props) => {
    const { disabled, inputData } = props;
 
    const rules = useMemo(() => {
        return inputData?.primaryForm?.form?.rules || []
    }, [inputData])

    return <Form.Item noStyle {...inputData?.prefixForm?.form} rules={rules}>
        <Select
            options={inputData?.prefixForm?.options || []}
            disabled={disabled}
        />
    </Form.Item>;
}